<svg
  [style.opacity]="opacity"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
>
  @if (hasGradient) {
  <defs>
    <linearGradient
      [attr.id]="gradientId"
      gradientUnits="userSpaceOnUse"
      x1="0"
      y1="0"
      x2="16"
      y2="16"
    >
      <stop offset="0%" [style.stop-color]="startColor" />
      <stop offset="100%" [style.stop-color]="endColor" />
    </linearGradient>
  </defs>
  }
  <rect
    x="1"
    y="1"
    width="6"
    height="6"
    rx="1"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : color || defaultColor"
  />
  <rect
    x="9"
    y="1"
    width="6"
    height="6"
    rx="1"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : color || defaultColor"
  />
  <rect
    x="1"
    y="9"
    width="6"
    height="6"
    rx="1"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : color || defaultColor"
  />
  <rect
    x="9"
    y="9"
    width="6"
    height="6"
    rx="1"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : color || defaultColor"
  />
</svg>
